/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AIConfigTargetingVariationJSON = {};

/** @internal */
export const AIConfigTargetingVariationJSON$inboundSchema: z.ZodType<
  AIConfigTargetingVariationJSON,
  z.ZodTypeDef,
  unknown
> = z.object({});
/** @internal */
export type AIConfigTargetingVariationJSON$Outbound = {};

/** @internal */
export const AIConfigTargetingVariationJSON$outboundSchema: z.ZodType<
  AIConfigTargetingVariationJSON$Outbound,
  z.ZodTypeDef,
  AIConfigTargetingVariationJSON
> = z.object({});

export function aiConfigTargetingVariationJSONToJSON(
  aiConfigTargetingVariationJSON: AIConfigTargetingVariationJSON,
): string {
  return JSON.stringify(
    AIConfigTargetingVariationJSON$outboundSchema.parse(
      aiConfigTargetingVariationJSON,
    ),
  );
}
export function aiConfigTargetingVariationJSONFromJSON(
  jsonString: string,
): SafeParseResult<AIConfigTargetingVariationJSON, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AIConfigTargetingVariationJSON$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AIConfigTargetingVariationJSON' from JSON`,
  );
}
